<template>
   <v-list
      dense
      nav
   >
      <v-list-item

         link
         :to="{ name: 'IdeasWorkbenchDashboard'}"
         active-class="primary--text"
         exact
      >
         <v-list-item-icon>
            <v-icon>mdi-view-dashboard</v-icon>
         </v-list-item-icon>

         <v-list-item-content>
            <v-list-item-title>Dashboard</v-list-item-title>
         </v-list-item-content>
      </v-list-item>

      <v-list-group
         prepend-icon="mdi-shape"
         no-action
      >
         <template v-slot:activator>
            <v-list-item-title>Kategorien</v-list-item-title>
         </template>
         <v-list-item
            link
            active-class="primary--text"
            :to="{ name: 'IdeasWorkbenchCategoriesCreate'}"
            v-if="$can('store ideasCategory')"
         >
            <v-list-item-content>
               <v-list-item-title class="primary--text">Neue Kategorie</v-list-item-title>
            </v-list-item-content>
            <v-list-item-icon>
               <v-icon>mdi-plus</v-icon>
            </v-list-item-icon>
         </v-list-item>
         <v-list-item
            v-for="(category, index) in categories" :key="index"
            link
            active-class="primary--text"
            exact
            :to="{ name: 'IdeasWorkbenchCategoriesShow', params: { id: category.id}}"
         >
            <v-list-item-content>
               <v-list-item-title>{{ category.name }}</v-list-item-title>
            </v-list-item-content>
         </v-list-item>
      </v-list-group>
      <v-list-item
         link
         active-class="primary--text"
         :to="{ name: 'IdeasWorkbenchIdeasCreate'}"
      >

         <v-list-item-icon>
            <v-icon>mdi-plus</v-icon>
         </v-list-item-icon>
         <v-list-item-content>
            <v-list-item-title class="primary--text">Neue Idee</v-list-item-title>
         </v-list-item-content>
      </v-list-item>
   </v-list>
</template>

<script>
export default {
   data: () => ({
      categories: {},
   }),
   computed: {
      activeCategory() {
         return [
            'IdeasWorkbenchCategoriesShow',
         ].includes(this.$route.name);
      }
   },
   created() {
      this.getCategories()
   },
   methods: {
      getCategories() {
         this.axios.get('/ideas-categories').then((r) => {
            this.categories = r.data.data;
         })
      }
   }
}
</script>

<style scoped>

</style>
